import { Text, Divider, Flex } from "@chakra-ui/react";
import React from "react";

export function OrDivider() {
  return (
    <Flex
      width="full"
      alignItems="center"
      justifyContent="center"
      position="relative"
    >
      <Divider borderColor="gray.400" />
      <Text position="absolute" bg="white" px={2}>
        or
      </Text>
    </Flex>
  );
}
